import React, { useState } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleLeft } from '@fortawesome/pro-regular-svg-icons/faArrowCircleLeft'

import { toast } from 'react-toastify'
import * as yup from 'yup'
import { Helmet } from 'react-helmet'

import { Heading } from '@peracto/peracto-ui'
import { CREATE, useClient, getSchemaFromResource } from '@peracto/client'

import { formatDataForAPI } from '../util'
import { MODE_ADD } from '../CategoryForm'

const CategoryAdd = ({ CategoryForm }) => {
    const { client, getResource } = useClient()
    const [redirect, setRedirect] = useState()

    const schema = getSchemaFromResource(getResource('categories')).shape({
        type: yup.string().when('template', (template, schema) => {
            return template === 'Product List' ? schema.required() : schema.notRequired()
        }),
        metaDescription: yup.string().nullable(),
    })

    const onSubmit = async (data, actions) => {
        const formattedData = formatDataForAPI(data)

        try {
            const response = await client(CREATE, 'categories', {
                data: {
                    // Set defaults to prevent error when not set
                    metaKeywords: [],
                    template: data.template || 'content-page',
                    filters: data.filters || [],
                    isDeleted: false,
                    ...formattedData,
                },
            })

            setRedirect('/categories')
            toast.success('Category successfully added!')
            actions.setSubmitting(false)
        } catch (e) {
            console.error(e)
            toast.error(
                e?.error?.body?.hasOwnProperty('hydra:description')
                    ? e.error.body['hydra:description']
                    : 'Whoops, there was a problem...'
            )

            if (e?.error?.body?.violations?.length > 0) {
                // Display errors for invalid fields
                actions.setSubmitting(false)
                e.error.body.violations.map(error => {
                    actions.setFieldError(error.propertyPath, error.message)
                })
            }

            actions.setSubmitting(false)
        }
    }

    if (redirect) {
        return <Redirect to={redirect} />
    }

    return (
        <>
            <Helmet>
                <title>Categories | Add | Peracto</title>
            </Helmet>
            <div className="form-container">
                <Heading name="Add Category">
                    <div className="!grow !flex !items-center !justify-end">
                        <Link
                            className="btn btn-outline-primary"
                            to="/categories"
                            data-testid="back-to-categories"
                        >
                            <FontAwesomeIcon icon={faArrowCircleLeft} className="!mr-2" />
                            Back to Categories
                        </Link>
                    </div>
                </Heading>
                <CategoryForm onSubmit={onSubmit} mode={MODE_ADD} schema={schema} />
            </div>
        </>
    )
}

export default CategoryAdd
